export default __webpack_public_path__ + "static/media/jeadee_img3.90fc385a.webp";